<template>
  <v-icon
    :name="'chevron-' + direction"
    :style="'display: inline-block; width:1rem; height: 1rem; margin: auto 5px; color: '+ color"
  ></v-icon>
</template>
<script>
export default {
  props: {
    direction: {
      type: String,
      default: "down"
    },
    color: {
      type: String,
      default: "inherit"
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/utils/direction-arrow.vue